interface Env {
  // Auth0
  auth0Domain: string;
  auth0AppClientID: string;
  auth0Audience: string;

  // Firebase
  apiKey: string;
  authDomain: string;
  projectID: string;

  participantsDNS: string;
  googleAnalyticsID: string;
  announceKitWidget: string;
  amplitudeApiKey: string;
  pingDomain: string;
}

interface WindowWithEnv extends Window {
  env?: Env;
}

const env: Env = (window as WindowWithEnv).env || {
  auth0Domain: 'instruqt-dev.eu.auth0.com',
  auth0AppClientID: 'mjgHFRe3Q17uXqwOVuvFCRWEum6WMFbK',
  auth0Audience: 'https://play.instruqt.dev/',
  apiKey: 'AIzaSyAwyZHlNjclUTZfs-M-KCmZUGscMi02xyY',
  authDomain: 'auth.play.instruqt.dev',
  projectID: 'instruqt-dev',
  participantsDNS: 'env.play.instruqt.dev',
  googleAnalyticsID: 'UA-110493831-6',
  announceKitWidget: 'ssPT2',
  amplitudeApiKey: 'd79118565eef4449c76cf4058860a752',
  pingDomain: 'https://ping.instruqt.dev',
};

export default env;
